import { useRouter } from 'found';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import MenuSlider from '../../components/MenuSlider';
import Page from '../../components/Page';
import Spacer from '../../components/Spacer';
import { PageTitle } from '../../components/typography/Typography';
import { routes } from '../../routes';
import Account from './Account';
import SubscriberBilling from './SubscriberBilling';
import { AccountSettings_account } from './__generated__/AccountSettings_account.graphql';

type Props = {
  account: AccountSettings_account;
};

function AccountSettings({ account }: Props) {
  const { router, match } = useRouter();

  if (!match.params.tab) {
    router.push(`${routes.accountSettings}/account`);
    return null;
  }
  return (
    <Page>
      <Spacer spacing={4} vertical />
      <PageTitle>Team Settings</PageTitle>
      <Spacer vertical spacing={3} />
      <MenuSlider
        options={[
          {
            text: 'Team',
            value: 'account',
          },
          {
            text: 'Billing',
            value: 'billing',
          },
        ]}
        selected={match.params.tab}
        onChange={(option) => {
          router.push(`${routes.accountSettings}/${option.value}`);
        }}
      />
      <Spacer vertical spacing={5} />
      {match.params.tab === 'account' && <Account account={account} />}
      {match.params.tab === 'billing' && (
        <SubscriberBilling account={account} />
      )}
    </Page>
  );
}

export default createFragmentContainer(AccountSettings, {
  account: graphql`
    fragment AccountSettings_account on Account {
      ...SubscriberBilling_account
      ...Account_account
    }
  `,
});
